import store from '@/store/index.js'
let dic = store.state.dic;

export default function Configs(that) {

    const searchItems = [
        {
            label: "地点名称",
            span: 8,
            placeholder: '请输入地点名称',
            model: "name"
        },
        {
            label: "详细地址",
            span: 8,
            placeholder: '请输入详细地址',
            model: "address"
        },
    ]
    const tableColumns = [
        {
            label: "地点名称",
            prop: "name",
            align: "center",
            show: true,
            minWidth: 180,
        },
        {
            label: "详细地址",
            prop: "address",
            align: "center",
            show: true,
            minWidth: 180,
        },
        {
            label: "关联事项",
            prop: "linkNames",
            align: "center",
            show: true,
            minWidth: 300,
        },
        {
            label: "经度",
            prop: "lng",
            align: "center",
            show: true,
            minWidth: 140,
        },
        {
            label: "纬度",
            prop: "lat",
            align: "center",
            show: true,
            minWidth: 140,
        },
        {
            label: "操作",
            name: "contr",
            align: "center",
            width: '200px',
            show: true
        }
    ]
    const formItems = [
        {
            label: "地点名称",
            span: 24,
            model: "name",
            placeholder: '请输入地点名称',
            labelClass: 'info-label',
        },
        {
            label: "详细地址",
            span: 24,
            model: "address",
            labelClass: 'info-label',
            placeholder: '请输入详细地址',
        },
        {
            label: "所属院系",
            span: 24,
            model: "collegeId",
            type: 'select',
            placeholder: '请选择所属院系',
            options: []
        },
        {
            label: "关联事项",
            span: 24,
            type: 'select',
            model: "idList",
            placeholder: '请选择关联事项',
            labelClass: 'info-label',
            multiple: true,
            options: [],
            change(e) {
                console.log(e)
            }
        },
        {
            label: "办理人",
            span: 24,
            model: "handlerIdList",
            type: 'select',
            multiple: true,
            placeholder: '请选择办理人',
            options: [],
        },
        {
            label: "经度",
            span: 24,
            model: "lng",
            placeholder: '请输入经度',
            labelClass: 'info-label',
        },
        {
            label: "纬度",
            span: 24,
            model: "lat",
            placeholder: '请输入纬度',
            labelClass: 'info-label',
        },
    ]

    const formRules = {
        name: [{
            required: true,
            trigger: "blur",
            message: '请输入点位名称'
        }],
        lat: [{
            required: true,
            trigger: "blur",
            message: '请输入纬度'
        }],
        lng: [{
            required: true,
            trigger: "blur",
            message: '请输入经度'
        }],
        collegeId: [{
            required: true,
            trigger: "blur",
            message: '请选择所属院系'
        }],
        address: [{
            required: true,
            trigger: "blur",
            message: '请输入具体位置'
        }],
        idList: [{
            required: true,
            trigger: "blur",
            message: '请选择关联事项'
        }],
    }
    return {
        searchItems,
        tableColumns,
        formItems,
        formRules
    }
}
